<script setup>
import { ref } from 'vue';

defineProps({
  directories: {
    type: Array,
    required: true
  },
  animationClass: {
    type: String,
    default: ''
  },
  keyPrefix: {
    type: String,
    required: true
  },
  isPaused: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['mouseenter', 'mouseleave']);

const erroredImages = ref(new Set());

const handleImageError = (imageUrl) => {
  erroredImages.value.add(imageUrl);
};

const isImageErrored = (imageUrl) => {
  return erroredImages.value.has(imageUrl);
};
</script>

<template>
  <div
    class="tw-flex tw-overflow-hidden tw-gap-1 scrollbar-hide"
    @mouseenter="emit('mouseenter')"
    @mouseleave="emit('mouseleave')"
  >
    <div
      class="tw-flex tw-gap-1 tw-will-change-transform"
      :class="[
        animationClass,
        { 'animation-paused': isPaused && animationClass }
      ]"
    >
      <div
        v-for="(directory, key) in animationClass ? [...directories, ...directories] : directories"
        :key="`${keyPrefix}-${key}`"
        v-tooltip="{
          content: directory.name,
          placement: 'bottom',
          theme: 'dark-blue-tooltip',
        }"
        class="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-20 tw-h-20 tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-neutral-300 tw-transition-all tw-duration-300 tw-ease-in-out tw-hover:scale-105 tw-cursor-pointer"
      >
        <img
          v-if="!isImageErrored(directory.url)"
          :src="directory.url"
          :alt="directory.alt"
          class="tw-max-w-full tw-max-h-full tw-object-contain tw-transition-opacity tw-duration-200"
          @error="handleImageError(directory.url)"
        >
        <svg-vue
          v-else
          icon="icons/uberall-placeholder"
          class="tw-max-w-full tw-max-h-full tw-object-contain"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Scrollbar hiding utility */
.scrollbar-hide {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Animation pause utility */
.animation-paused {
  animation-play-state: paused !important;
}
</style>
